import { FileCategories } from '@/types/api';

export const getFileInputAcceptType = (categoryType: string): string => {
  const isResumeCategory = categoryType === FileCategories.RESUME;

  if (isResumeCategory) {
    return 'application/pdf';
  }

  return 'application/pdf,.doc,.docx';
};
